import { EnumValues } from "@hex/common";

export namespace ContextWorkbenchPublish {
  export const View = {
    CHANGES: "changes",
    RESOURCES: "resources",
    ASK_PREVIEW: "ask-preview",
  } as const;
  export type View = EnumValues<typeof View>;

  export const Surface = {
    GUIDES_PREVIEW: "guidesPreview",
    UNIFIED_PREVIEW: "unifiedPreview",
  } as const;
  export type Surface = EnumValues<typeof Surface>;

  export const SURFACE_CONFIG: Record<
    Surface,
    { readonly tabs: readonly View[]; readonly defaultView: View }
  > = {
    [Surface.GUIDES_PREVIEW]: {
      tabs: [View.CHANGES, View.ASK_PREVIEW],
      defaultView: View.ASK_PREVIEW,
    },
    [Surface.UNIFIED_PREVIEW]: {
      tabs: [View.RESOURCES, View.ASK_PREVIEW],
      defaultView: View.ASK_PREVIEW,
    },
  };

  export const ChangesFilter = {
    ALL: "all",
    CHANGED: "changed",
  } as const;
  export type ChangesFilter = EnumValues<typeof ChangesFilter>;

  export type FormData = {
    title: string;
    description: string;
  };
}
